export default __webpack_public_path__ + "static/media/step_img_10.7101bf01.png";